import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-copyright',
    templateUrl: './copyright.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CopyrightComponent {

}
